module.exports = __webpack_public_path__ + "img/gr.646178a3.svg";